import Vue from "vue";
import Vuetify from "vuetify/lib";
import NasIcon from "@/components/Icones/nas.vue";
import PmsIcon from "@/components/Icones/pms.vue";
import PortailsIcon from "@/components/Icones/portails.vue";
import PortalModelIcon from "@/components/Icones/portal-models.vue";
import MacAdressIcon from "@/components/Icones/mac.vue";
import CbTransactionIcon from "@/components/Icones/cb-transaction.vue";
import PartenaireIcon from "@/components/Icones/partenaire.vue";
import GroupesIcon from "@/components/Icones/groupes.vue";
import SavIcon from "@/components/Icones/sav.vue";
import EditionIcon from "@/components/Icones/edition.vue";
import CarteIcon from "@/components/Icones/carte.vue";
import PassmanIcon from "@/components/Icones/passman.vue";
import ToposIcon from "@/components/Icones/topos.vue";
import ColorResetIcon from "@/components/Icones/color-reset.vue";
import PaletteIcon from "@/components/Icones/palette.vue";

Vue.use(Vuetify);

export default new Vuetify({
  icons: {
    iconfont: "mdiSvg", // 'mdi' || 'mdiSvg' || 'md' || 'fa' || 'fa4' || 'faSvg'
    values: {
      nas: {
        component: NasIcon,
      },
      pms: {
        component: PmsIcon,
      },
      portails: {
        component: PortailsIcon,
      },
      portal_model: {
        component: PortalModelIcon,
      },
      mac: {
        component: MacAdressIcon,
      },
      cb_transaction: {
        component: CbTransactionIcon,
      },
      partenaire: {
        component: PartenaireIcon,
      },
      groupes: {
        component: GroupesIcon,
      },
      sav: {
        component: SavIcon,
      },
      edition: {
        component: EditionIcon,
      },
      carte: {
        component: CarteIcon,
      },
      passman: {
        component: PassmanIcon,
      },
      topos: {
        component: ToposIcon,
      },
      color_reset: {
        component: ColorResetIcon,
      },
      palette: {
        component: PaletteIcon,
      },
    },
  },
  theme: {
    themes: {
      light: {
        primary: {
          base: "#000000",
          lighten1: "rgba(0,0,0,0.54)",
        },
        accent: "#000000",
        error: "#fe4d0d",
        info: "#0d45fe",
        success: "#45fe0d",
        warning: "#fec40d",
      },
    },
  },
});
